import React, { useCallback, useEffect, useRef, useState } from 'react';
import './NotChrome.scss';

export const NotChrome = () => {

    return (
    <div className="not-chrome-container">
      <div className="not-chrome-center">
        <div className="logo"></div>

        <h2>BlueJeans Studio is only supported on Google Chrome</h2>
        <p>To use BlueJeans Studio on this device, please switch to Google Chrome.</p>
        <p>Don&apos;t have Chrome? Download it <a href="https://www.google.com/chrome/" target="blank">here</a>.</p>
        <div className="chrome"></div>
      </div>
    </div>
    )
}